import { render, staticRenderFns } from "./PaymentDiscounts.vue?vue&type=template&id=a38b3510&scoped=true&"
import script from "./PaymentDiscounts.vue?vue&type=script&lang=js&"
export * from "./PaymentDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDiscounts.vue?vue&type=style&index=0&id=a38b3510&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38b3510",
  null
  
)

export default component.exports